import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * @file
 * @author dailin01
 */
import React, { useContext } from 'react';
import classNames from 'classnames';
import MenuContext from './MenuContext';
import { cloneElement } from '../_util/reactNode';
var HeaderMenu = function HeaderMenu(props) {
  var headerMenu = props.headerMenu,
    viceHeaderMenu = props.viceHeaderMenu,
    logoInfo = props.logoInfo,
    titleInfo = props.titleInfo,
    otherArea = props.otherArea,
    headerStyle = props.headerStyle;
  /**
   * logo string - imgString + url  ReactNode - selfCus
   * title
   * subTitleUrl
   * headerMenu
   * viceHeaderMenu
   * otherArea
   */
  var _useContext = useContext(MenuContext),
    prefixCls = _useContext.prefixCls;
  var logo = logoInfo.logo,
    logoUrlConfig = logoInfo.urlConfig;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header"),
    style: headerStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header-head")
  }, /*#__PURE__*/React.createElement("a", _extends({
    className: "".concat(prefixCls, "-header-logo")
  }, logoUrlConfig), logo && typeof logo === 'string' ? /*#__PURE__*/React.createElement("img", {
    src: logo
  }) : logo), !!titleInfo && (typeof titleInfo.title === 'string' ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header-title")
  }, /*#__PURE__*/React.createElement("a", titleInfo.urlConfig, titleInfo.title)) : titleInfo.title)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-header-nav")
  }, cloneElement(headerMenu, {
    mode: 'horizontal',
    className: classNames("".concat(prefixCls, "-header-nav-menu"), 'acud-menu-with-icon')
  }), cloneElement(viceHeaderMenu, {
    mode: 'horizontal',
    className: classNames("".concat(prefixCls, "-header-nav-menu"), "".concat(prefixCls, "-header-nav-menu-vice"), 'acud-menu-with-icon')
  })), !!otherArea && cloneElement(otherArea, {
    className: "".concat(prefixCls, "-header-area")
  })));
};
export default HeaderMenu;